var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChartAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4176 0.83333C10.4176 0.372905 10.0447 0 9.58431 0C9.12388 0 8.75098 0.372905 8.75098 0.83333V10.2666L8.76035 10.2573C9.21139 9.81976 9.82182 9.62184 10.4176 9.6812L10.4176 0.83333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58366 8.33338V14.3022L2.91699 15.9157V8.33333C2.91699 7.87291 3.2899 7.5 3.75032 7.5C4.21075 7.5 4.58366 7.87296 4.58366 8.33338Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58366 20.1016L2.91699 21.7151V24.1661C2.91699 24.6266 3.2899 24.9995 3.75032 24.9995C4.21075 24.9995 4.58366 24.6266 4.58366 24.1661V20.1016Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4176 14.4531L8.75098 16.0667V18.7499C8.75098 19.2103 9.12388 19.5832 9.58431 19.5832C10.0447 19.5832 10.4176 19.2103 10.4176 18.7499V14.4531Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.584 22.9147V16.7771C15.1402 16.9521 15.7465 16.8854 16.2506 16.5938V22.9145C16.2506 23.3749 15.8777 23.7479 15.4173 23.7479C14.9569 23.7479 14.584 23.3751 14.584 22.9147Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8335 21.0268V12.1092L22.5002 10.832V21.0268C22.5002 21.3796 22.1273 21.6653 21.6668 21.6653C21.2064 21.6653 20.8335 21.3796 20.8335 21.0268Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4175 3.75012H22.0841V0.83333C22.0841 0.372905 21.7112 0 21.2508 0C20.7904 0 20.4175 0.372905 20.4175 0.83333V3.75012Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8923 12.1614L16.2506 10.8041V8.33333C16.2506 7.87291 15.8777 7.5 15.4173 7.5C14.9569 7.5 14.584 7.87291 14.584 8.33333V11.9738L14.8923 12.1614Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5837 5.83333C19.5837 5.37291 19.9566 5 20.417 5H24.1669C24.6273 5 25.0002 5.37291 25.0002 5.83333V9.58318C25.0002 10.0436 24.6273 10.4165 24.1669 10.4165C23.7065 10.4165 23.3336 10.0436 23.3336 9.58318V7.84466L15.7981 15.3812C15.5263 15.652 15.1044 15.703 14.7763 15.5041L10.3261 12.8009L1.41362 21.432C1.12405 21.7123 0.683411 21.7404 0.363625 21.5216C0.31779 21.4904 0.275084 21.4539 0.234457 21.4133C0.154249 21.33 0.0948734 21.2352 0.0563321 21.1341C-0.00720908 20.9716 -0.0165851 20.7935 0.0261242 20.6258C0.0625828 20.4821 0.138625 20.3456 0.253206 20.2341L9.62812 11.156C9.90103 10.8915 10.3167 10.8456 10.6406 11.0415L15.0811 13.7393L22.155 6.66654H20.4165C19.956 6.66654 19.5831 6.29363 19.5831 5.83321L19.5837 5.83333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartAnalytics);
export default __webpack_public_path__ + "static/media/barChartAnalytics.9516fd483464ac85cbb10b70f8d7762e.svg";
export { ForwardRef as ReactComponent };